
export default function HeroSection() {
  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* YouTube Video Background */}
      <div className="absolute inset-0 w-full h-full">
        <iframe
          src="https://www.youtube.com/embed/RWl_uGmaEMc?autoplay=1&mute=1&loop=1&playlist=RWl_uGmaEMc&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&disablekb=1&fs=0&cc_load_policy=0&playsinline=1&enablejsapi=0"
          className="absolute top-1/2 left-1/2 w-full h-full object-cover transform -translate-x-1/2 -translate-y-1/2 scale-150"
          style={{
            minWidth: '100vw',
            minHeight: '100vh',
            width: '177.77777778vh', // 16:9 aspect ratio
            height: '56.25vw', // 16:9 aspect ratio
          }}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          title="Aviation Training Background Video"
        />
        
        {/* Fallback Background Image */}
        <div 
          className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20aviation%20training%20facility%20with%20small%20aircraft%20on%20grass%20runway%20in%20Central%20Texas%2C%20clear%20blue%20sky%2C%20modern%20flight%20training%20environment%2C%20tailwheel%20aircraft%2C%20cessna%20planes%2C%20professional%20aviation%20photography%2C%20warm%20lighting%2C%20inviting%20atmosphere%2C%20flight%20school%20setting&width=1920&height=1080&seq=hero-aviation&orientation=landscape')`,
            zIndex: -1
          }}
        />
        
        {/* Dark Overlay for Text Readability */}
        <div className="absolute inset-0 bg-black bg-opacity-40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
            Flight Training The Right Way
          </h1>
          <h2 className="text-2xl md:text-3xl font-semibold mb-8 text-gray-200">
            Central Texas Tailwheel Training
          </h2>
          <p className="text-xl md:text-2xl mb-10 text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Learning to fly in the relaxed environment here at Stiletto Airpark is as easy and cost-effective as it gets! Master the skills every pilot should have with our comprehensive <strong>flight training </strong> programs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:706-936-8961"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-xl font-bold hover:bg-teal-700 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call: 706-936-8961 To Book Now!
            </a>
            <a 
              href="#training"
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-xl font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Training Programs
            </a>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce z-10">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
}
